import { render, staticRenderFns } from "./AmiiboTracker.vue?vue&type=template&id=32164594&"
import script from "./AmiiboTracker.vue?vue&type=script&lang=js&"
export * from "./AmiiboTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports